export default __webpack_public_path__ + "static/media/vguard.7a8d9f8b.png";